<div class="section-header no-border layout_one_up_center">
  Welcome to the USAN Application Portal
</div>
<div class="layout small-gap" *ngIf="isDisplayingError">
  <div class="role-text">
    <span class="text-line">
      It looks like you do not currently have access to this page. This could be because your account 
      isn&apos;t linked to an organization or your permissions haven&apos;t been set up yet.
    </span>
    <span class="text-line">Here&apos;s what you can do:</span>
    <span class="text-line">
       <ul>
        <li>
          <b>If you belong to an applying organization</b>, please contact your organization&apos;s administrator 
          to request access.
        </li>
        <li>
          <b>If you are new to USAN</b>, reach out to the USAN Team at 
          <a href="mailto:usan@ama-assn.org">usan@ama-assn.org</a> or click <b>Contact USAN</b> for assistance.
        </li>
       </ul>
    </span>
  </div>
</div>
<div class="layout small-gap" *ngIf="isDisplayingRoleSelection">
  <div class="role-text">
    <span class="text-line">
      You have multiple roles available. Please choose the role that you would like to proceed with.
    </span>
    <div class="role-buttons-container">
      <ng-container *ngFor="let role of userRoles">
        <button class="role-button role-btn-style role-btn-text" (click)="selectUserRole(role)">{{ role }}</button>
      </ng-container>
    </div>
    <p class="role-switch-info-text text-line">
      If you need to switch roles, click on the <i>My Account</i> link in the top right corner and then
      on the <i>Switch Roles</i> link to return to this page.
    </p>
  </div>
</div>
